<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="编辑保养项"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="800px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="110px"
      >
        <el-form-item label="保养项目：" prop="itemName">
          <el-input
            size="mini"
            v-model.trim="form.itemName"
            placeholder="请输入保养项目"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="保养部位：" class="mr0">
          <el-select
            size="mini"
            v-model="locationObj"
            filterable
            placeholder="请选择保养部位"
            clearable
            reserve-keyword
            :remote="true"
            @change="chooseLocation"
            :remote-method="searchLocationList"
            @visible-change="searchLocationList('')"
            value-key="id"
          >
            <el-option
              v-for="item in locationList"
              :key="item.id"
              :label="item.locationName"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否必填：">
          <el-select
            size="mini"
            v-model="form.optionalStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in isSignList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保养要求：" class="mr0">
          <el-input
            size="mini"
            v-model.trim="form.requirements"
            placeholder="请输入保养要求"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="排序号：">
          <el-input
            size="mini"
            v-number-only:20
            v-model.trim="form.sortOrder"
            placeholder="请输入排序号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="保养类型：" class="mr0">
          <el-select
            size="mini"
            v-model="maintainTypeObj"
            value-key="code"
            @change="selectMaintainType"
          >
            <el-option
              v-for="item in bylxList"
              :key="item.code"
              :label="item.name"
              :value="item"
              placeholder="请选择保养类型"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维保周期代码：">
          <el-input
            size="mini"
            v-model.trim="form.masterPlatformMaintainPeriodCode"
            placeholder="请输入主平台-维保周期代码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="维保周期名称：" class="mr0">
          <el-input
            size="mini"
            v-model.trim="form.masterPlatformMaintainPeriodName"
            placeholder="请输入主平台-维保周期名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="维保周期id：">
          <el-input
            size="mini"
            v-model.trim="form.masterPlatformMaintainPeriodId"
            placeholder="请输入主平台-维保周期id"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="维保周期明细id：" class="mr0">
          <el-input
            size="mini"
            v-model.trim="form.masterPlatformMaintainPeriodDetailId"
            placeholder="请输入主平台-维保周期明细id"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="维保项目代码：">
          <el-input
            size="mini"
            v-model.trim="form.masterPlatformMaintainItemCode"
            placeholder="请输入主平台-维保项目代码"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  addTerm,
  getLocationSimpleList,
  getMaintainTypeList,
} from "@/api/MaintenanceItems";
import { mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        itemName: "",
        optionalStatus: "",
        requirements: "",
        sortOrder: "",
        maintainTypeCode: "",
        maintainTypeName: "",
        maintainLocationId: "",
        maintainLocationName: "",
      },
      rules: {
        itemName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
      },
      loadBtn: false,
      isSignList: [
        {
          code: "1",
          name: "是",
        },
        {
          code: "2",
          name: "否",
        },
      ],
      locationList: [],
      locationObj: null,
      maintainTypeObj: null,
      bylxList: [],
    };
  },
  computed: {
    ...mapState("common/dictionary", ["bylxDicts"]),
  },
  props: {
    editData: {
      type: Object,
      default: () => {},
    },
    templateId: {
      required: true,
    },
  },
  created() {
    this.searchLocationList();
    this.form = { ...this.editData };
    this.getBylxList();
    this.locationObj = {
      id: this.form.maintainLocationId,
      locationName: this.form.maintainLocationName,
    };
    if (this.form.maintainTypeCode) {
      this.maintainTypeObj = {
        code: this.form.maintainTypeCode * 1,
        name: this.form.maintainLocationName,
      };
    }
  },
  methods: {
    async getBylxList() {
      const res = await getMaintainTypeList();
      if (res.code === 200) {
        this.bylxList = res.data;
      }
    },
    async searchLocationList(keyword) {
      const res = await getLocationSimpleList({
        locationName: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.locationList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const params = { ...this.form };
          if (params.sortOrder) {
            params.sortOrder = params.sortOrder * 1;
          }
          params.templateId = this.templateId;
          const res = await addTerm(params);
          if (res.code === 200) {
            this.$message.success("编辑成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
    selectMaintainType(val) {
      console.log(val);
      if (val) {
        // this.bylxDicts.forEach((item) => {
        //   if (val === item.dictionaryCode) {
        //     this.form.maintainTypeCode = item.code * 1;
        //     this.form.maintainTypeName = item.dictionaryValue;
        //   }
        // });
        this.form.maintainTypeCode = val.code * 1;
        this.form.maintainTypeName = val.name;
      } else {
        this.form.maintainTypeName = "";
      }
    },
    chooseLocation(val) {
      if (val) {
        this.form.maintainLocationId = val.id;
        this.form.maintainLocationName = val.locationName;
      } else {
        this.form.maintainLocationId = "";
        this.form.maintainLocationName = "";
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/MaintenanceItems/components/EditTerm.vue